import { NgModule } from '@angular/core';
import { BaseSignContractAnimatedStatusButtonComponent } from './_components/base-sign-contract-animated-status-button/base-sign-contract-animated-status-button.component';
import { BaseSharedModule } from '../../shared/base-shared.module';
import { BaseSignContractStatusTooltipComponent } from './_components/base-sign-contract-status-tooltip/base-sign-contract-status-tooltip.component';
import { BaseSignContractErrorStatusTooltipComponent } from './_components/base-sign-contract-error-status-tooltip/base-sign-contract-error-status-tooltip.component';

@NgModule({
  imports: [BaseSharedModule],
  declarations: [
    BaseSignContractAnimatedStatusButtonComponent,
    BaseSignContractStatusTooltipComponent,
    BaseSignContractErrorStatusTooltipComponent,
  ],
  exports: [
    BaseSignContractAnimatedStatusButtonComponent,
    BaseSignContractStatusTooltipComponent,
    BaseSignContractErrorStatusTooltipComponent,
  ],
})
export class BaseAssignmentsModule {}
